'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

export const MAX_DISPLAYED_CART_COUNT = 9;

interface HeaderCartBadgeProps {
  itemCount: number;
}

export function HeaderCartBadge({ itemCount }: HeaderCartBadgeProps) {
  if (itemCount <= 0) {
    return null;
  }

  return (
    <span
      aria-hidden="true"
      className="pointer-events-none relative -ml-3 inline-flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-warning-200 px-1 text-xs font-bold text-warning-800"
      data-testid={DataTestIdEnum.CART_HEADER_BADGE}
    >
      {itemCount > MAX_DISPLAYED_CART_COUNT ? `${MAX_DISPLAYED_CART_COUNT}+` : itemCount}
    </span>
  );
}
